/* TF · Carrusel de videos — marquee horizontal infinito (auto + hover-pausa + arrastre
 * + loop sin saltos) con videos autoplay muted/loop, carga y reproducción por visibilidad
 * (IntersectionObserver) y audio exclusivo por tap. Sin librerías. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    var vp = section.querySelector('[data-tf-vcar-viewport]');
    var track = section.querySelector('[data-tf-vcar-track]');
    if (!vp || !track || track.__vcarInit) return;
    track.__vcarInit = true;

    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (!n) return;

    // Clonar 2 veces (3 sets) para loop continuo sin bordes visibles.
    for (var k = 0; k < 2; k++) {
      originals.forEach(function (c) {
        var cl = c.cloneNode(true);
        cl.setAttribute('aria-hidden', 'true');
        cl.classList.add('is-clone');
        cl.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = -1; });
        track.appendChild(cl);
      });
    }

    var dir = section.getAttribute('data-direction') === 'ltr' ? -1 : 1;
    var speed = parseFloat(section.getAttribute('data-speed')); if (isNaN(speed)) speed = 34;
    var autoOn = section.getAttribute('data-autoplay') !== 'false';
    var pauseHover = section.getAttribute('data-pause-hover') !== 'false';

    /* ---- Audio exclusivo ---- */
    var audioVideo = null; // el único con sonido activo
    function mark(v, on) { var card = v && v.closest('.tf-vcar__card'); if (card) card.classList.toggle('is-unmuted', !!on); var b = card && card.querySelector('[data-tf-vcar-sound]'); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    function clearAudio() { if (audioVideo) { audioVideo.muted = true; mark(audioVideo, false); audioVideo = null; } }
    function setAudio(v) {
      if (audioVideo && audioVideo !== v) { audioVideo.muted = true; mark(audioVideo, false); }
      v.muted = false; var p = v.play(); if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {});
      audioVideo = v; mark(v, true);
    }

    function loadVideo(v) {
      if (v.__loaded) return; v.__loaded = true;
      v.querySelectorAll('source[data-src]').forEach(function (so) { if (!so.getAttribute('src')) so.setAttribute('src', so.getAttribute('data-src')); });
      v.load();
    }

    /* ---- Reproducir/pausar SOLO lo visible ---- */
    var vids = track.querySelectorAll('[data-tf-vcar-video]');
    if (!reduce && 'IntersectionObserver' in window && vids.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            loadVideo(v);
            var p = v.play(); if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {}); else v.classList.add('is-playing');
          } else {
            v.pause(); v.classList.remove('is-playing');
            if (v === audioVideo) clearAudio(); // si sale de vista con sonido, silenciar y reanudar auto
          }
        });
      }, { root: vp, rootMargin: '0px 200px', threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
    }

    /* ---- Arrastre (mouse) + medición del loop ---- */
    var hovering = false, down = false, startX = 0, prevX = 0, moved = false;
    vp.addEventListener('pointerenter', function () { hovering = true; });
    vp.addEventListener('pointerleave', function () { hovering = false; });
    vp.addEventListener('pointerdown', function (e) {
      down = true; moved = false; startX = e.clientX; prevX = e.clientX;
      vp.classList.add('is-dragging');
      if (e.pointerType === 'mouse') { try { vp.setPointerCapture(e.pointerId); } catch (_) {} }
    });
    vp.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (e.pointerType === 'mouse') { vp.scrollLeft -= (e.clientX - prevX); }
      prevX = e.clientX;
      if (Math.abs(e.clientX - startX) > 4) moved = true;
    });
    function up() { down = false; vp.classList.remove('is-dragging'); }
    vp.addEventListener('pointerup', up);
    vp.addEventListener('pointercancel', up);

    /* ---- Tap = alternar audio (no en arrastre; el enlace navega aparte) ---- */
    vp.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); return; }
      if (e.target.closest('.tf-vcar__cta')) return; // el botón "Ver más" navega
      var card = e.target.closest('.tf-vcar__card'); if (!card) return;
      var v = card.querySelector('[data-tf-vcar-video]'); if (!v) return;
      e.preventDefault();
      loadVideo(v);
      if (v === audioVideo) clearAudio(); else setAudio(v);
    });

    var period = 0;
    function measure() {
      period = track.children[n].offsetLeft - track.children[0].offsetLeft;
      if (dir < 0 && vp.scrollLeft < 1 && period > 0) vp.scrollLeft = period;
    }
    addEventListener('resize', measure, { passive: true });
    measure(); setTimeout(measure, 60);
    if (document.readyState !== 'complete') addEventListener('load', measure, { once: true });

    var last = performance.now();
    function frame(now) {
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (period > 0) {
        var paused = reduce || down || !autoOn || speed <= 0 || (pauseHover && hovering) || audioVideo;
        if (!paused) vp.scrollLeft += dir * speed * dt;
        if (vp.scrollLeft >= period) vp.scrollLeft -= period;
        else if (vp.scrollLeft <= 0) vp.scrollLeft += period;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function boot(root) { (root || document).querySelectorAll('[data-tf-vcar]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
